// 済表示ボタン
import React, { useEffect, useState } from 'react';

interface Props {
  label: string;
  handleClick?: VoidFunction;
  is_done: boolean;
  className?: string;
}

const DoneButton: React.FC<Props> = ({ label, handleClick, is_done, className }) => {
  return (
    <a
      className={`btn btn-bg-white btn-outline-success btn-text-color btn-system  ${
        is_done && 'btn-done'
      } ${className}`}
      onClick={handleClick}
    >
      {label}
    </a>
  );
};

export default DoneButton;
